import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import { addVisibilityWatcher } from "web/script/modules/run-loop";


export default baustein.register("price-history-bullet-points", {
    _sendEvent(name) {
        analytics.event("price-history", "price-history-summary", name, true);
    },

    onInsert() {
        this._removeVisiblityWatcher = addVisibilityWatcher(this.el, (visible) => {
            if (visible) {
                this._removeVisiblityWatcher();
                this._sendEvent("price-history-summary-viewed");
            }
        });
    },

    init() {
        this._sendEvent("price-history-summary-loaded");
    },
});
